import { useContext, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { AuthContext } from '@/context/auth-context'
import { PostSignupPhoneStatus } from '@/firebase/auth/auth-jwt-schema'
import { isPostSignupPhoneEligible, kPostSignupPhonePath } from '@/onboarding/post-signup-phone-routing'

type PostSignupPhoneGuardProps = {
  children: ReactNode
}

export function PostSignupPhoneGuard({ children }: PostSignupPhoneGuardProps) {
  const { userAccountData } = useContext(AuthContext)
  const phoneCollectionEnabled = kGetFeatureFlagStatus(kFeatureFlags.POST_SIGNUP_PHONE_COLLECTION)

  if (
    phoneCollectionEnabled &&
    userAccountData &&
    isPostSignupPhoneEligible(userAccountData) &&
    userAccountData.postSignupPhoneStatus === PostSignupPhoneStatus.REQUIRED
  ) {
    return <Navigate to={kPostSignupPhonePath} replace />
  }

  return children
}
